<template>
  <div class="admin">
    <div class="page-wrapper default-theme sidebar-bg bg1 toggled">
      <a
        id="show-sidebar"
        @click="closeMenu"
        class="btn btn-sm btn-dark"
        href="#"
      >
        <i class="fas fa-bars"></i>
      </a>
      <nav id="sidebar" class="sidebar-wrapper">
        <div class="sidebar-content">
          <!-- sidebar-brand  -->
          <div class="sidebar-item sidebar-brand">
            <!-- <a href="#">Bulky TMS</a> -->
            <a href="#">
              <img
                class="img-responsive"
                src="/img/BulkyTMSLogo.png"
                alt="Bulky Logo"
              />
            </a>
            <div id="close-sidebar" @click="closeMenu">
              <i class="fas fa-times"></i>
            </div>
          </div>
          <!-- sidebar-header  -->
          <div class="sidebar-item sidebar-header">
            <div class="user-pic">
              <img
                class="img-responsive img-rounded"
                src="/img/Dexter.png"
                alt="User picture"
              />
            </div>
            <div class="user-info">
              <span class="user-name">
                <strong>{{user.isAdmin ? "Administrator" : "User" }}</strong>
              </span>
              <span class="user-role">{{ email }}</span>
              <span class="user-status">
                <i class="fa fa-circle"></i>
                <span>Online</span>
              </span>
            </div>
          </div>

          <!-- sidebar-menu  -->
          <div class="sidebar-item sidebar-menu">
            <ul>
              <li class="header-menu">
                <span>Home</span>
              </li>

              <li v-if="premium == 'yes'">
                <router-link to="/">
                  <i class="fas fa-coffee"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="An overview of the BULKY TMS software"
                    >Overview</span
                  >
                </router-link>
              </li>

              <li class="header-menu" v-if="premium == 'yes'">
                <span>Requests</span>
              </li>

              <li>
                <router-link to="/empmyrequests">
                  <i class="far fa-file-alt"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Add new requests, or view past requests you've personally added."
                    >My Requests</span
                  >
                </router-link>
              </li>

              <li v-if="user.isAdmin">

                <router-link to="/empallrequests">
                  <i class="far fa-folder-open"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="View all requests submitted by both residents and admins."
                    >All Requests</span
                  >
                </router-link>
              </li>

              <li v-if="user.isAdmin">
                <router-link to="/unverified">
                  <i class="fas fa-exclamation-circle"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="View all unverified requests"
                    >Unverified</span
                  ><span v-if="unverifiedCount() > 0" class="badge badge-pill badge-danger" style="margin-top:5px">{{this.unverifiedCount()}}</span>
                </router-link>
              </li>

              <li class="header-menu" v-if="user.isAdmin">
                <span>Tools</span>
              </li>

              <li v-if="user.isAdmin">
                <router-link to="/bulktrashsettings">
                  <i class="fas fa-cog"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Adjust global settings (i.e., Trash Types, Pickup Days, etc) and modes"
                    >Settings</span
                  >
                </router-link>
              </li>

              <li class="header-menu">
                <span>Account</span>
              </li>

              <li>
                <router-link to="/profile">
                  <i class="fa fa-user"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Add or change profile settings"
                    >Profile</span
                  >
                </router-link>
              </li>

              <li>
                <a href="#" @click="logout()">
                  <i class="fa fa-power-off"></i>
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Logout of the BULKY TMS system"
                    >Logout</span
                  >
                </a>
              </li>
            </ul>
            <div class="ml-3 mt-5" v-if="usePremium == true">
              <button
                @click="premiumOn()"
                type="button"
                class="btn btn-primary btn-success btn-sm"
                v-if="premium == 'no' && user.isAdmin"
              >
                Turn Premium On
              </button>
              <button
                @click="premiumOff()"
                type="button"
                class="btn btn-primary btn-warning btn-sm"
                v-if="premium == 'yes' && user.isAdmin"
              >
                Turn Premium Off
              </button>
            </div>
          </div>
          <!-- sidebar-menu  -->
        </div>
      </nav>
      <!-- sidebar-content  -->
      <main class="page-content">
        <router-view />
      </main>
      <!-- page-content" -->
    </div>
    <!-- page-wrapper -->
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import { fb, db } from "../firebase";
import { mapState, mapGetters } from "vuex";

export default {
  name: "admin",
  data() {
    return {
      name: null,
      email: null,
      premium: null,
      role: null,
      admin: null,
      usePremium: false
    };
  },
  components: {
    Hero,
  },

    computed: {
    ...mapGetters({
      user: "user",
    }),
    ...mapState(["allRequests"]),
  },
  // premiumOn()/Off only used for testing
  methods: {
    unverifiedCount() {
          var unverifiedList = [];
          this.allRequests.forEach(item => {
            if(item.req_zone == null || item.req_zone == "")
                  unverifiedList.push(item)
          })

          return unverifiedList.length;
    },
    premiumOn() {
      this.premium = "yes";
    },
    premiumOff() {
      this.premium = "no";
    },
    closeMenu() {
      $(".page-wrapper").toggleClass("toggled");
    },
    logout() {
      fb.auth()
        .signOut()
        .then(() => {
          this.$router.replace("/");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  // Function created
  created() {
    var user = fb.auth().currentUser;
    this.email = user.email;
    this.name = user.uid;
    // this.premium was only used for testing
    this.premium = "no";
    this.role = user.role;
  },
};
</script>

<style>
</style>